/*
 * This code is protected by intellectual property rights.
 * Dr. Ing. h.c. F. Porsche AG owns exclusive rights of use.
 * © 2017-2026, Dr. Ing. h.c. F. Porsche AG.
 */

import { Injectable, inject } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '../../../../../apps/myprofile-ui/src/environments/environment'

export interface MfaDto {
  mfaEnabled: boolean
  mfaSmsEnrolled: boolean
}

@Injectable({
  providedIn: 'root',
})
export class MfaService {
  private httpClient = inject(HttpClient)

  getMfaStatus(): Observable<MfaDto> {
    return this.httpClient.get<MfaDto>(`${environment.mfaApi.baseUrl}/api/v2/account/mfa/status`)
  }
}
